import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "featuredArticle" }
const _hoisted_2 = {
  key: 0,
  class: "vid-wrap"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "captionBanner desktop"
}
const _hoisted_5 = {
  key: 1,
  class: "img-wrap"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  class: "captionBanner desktop"
}
const _hoisted_9 = {
  key: 2,
  class: "captionBanner mobile"
}
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "intro" }
const _hoisted_14 = { class: "bottom" }
const _hoisted_15 = { class: "author-date" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1)
const _hoisted_17 = { class: "right" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "author-wrap" }
const _hoisted_20 = { class: "author-content" }
const _hoisted_21 = { class: "author-name" }
const _hoisted_22 = { class: "country" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 1,
  class: "carousel-wrapper"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("related"),
  /*#__PURE__*/_createElementVNode("span", null, "قراءات مماثلة")
], -1)

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Carousel = _resolveComponent("Carousel")
  const _component_Lightbox = _resolveComponent("Lightbox")

  return (_openBlock(), _createElementBlock("div", {
    id: "blogPost",
    class: _normalizeClass(["view", {'scrolled': _ctx.scrolled}])
  }, [
    (_ctx.activePost)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["post", _ctx.activePost.custom_fields.language+' '+_ctx.activePost.custom_fields.type])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.activePost.custom_fields.type == 'video')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: "video-banner",
                    innerHTML: _ctx.activePost.custom_fields.video
                  }, null, 8, _hoisted_3),
                  (_ctx.activePost.custom_fields.caption)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.activePost.custom_fields.caption), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.activePost.custom_fields.banner && _ctx.activePost.custom_fields.banner.url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.activePost.custom_fields.banner.url
                      }, null, 8, _hoisted_6))
                    : (_ctx.activePost.custom_fields.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.activePost.custom_fields.image.url
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                  (_ctx.activePost.custom_fields.caption)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.activePost.custom_fields.caption), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])),
            (_ctx.activePost.custom_fields.caption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.activePost.custom_fields.caption), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.activePost.post_title)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.activePost.post_title), 1))
                : (_openBlock(), _createElementBlock("h3", _hoisted_12, "This article doesn't exist.")),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.activePost.custom_fields.intro_text), 1),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.activePost.category && _ctx.activePost.category.length > 0)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'cat', params: {name: decodeURIComponent(_ctx.activePost.category[0].slug)}},
                      class: "category"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.activePost.category[0].name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_15, [
                  _createTextVNode(_toDisplayString((_ctx.activePost.custom_fields.author ? _ctx.activePost.custom_fields.author.post_title : '')) + " - ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.activePost.custom_fields.date), 1)
                ])
              ])
            ])
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: "content",
              innerHTML: _ctx.activePost.post_content
            }, null, 8, _hoisted_18),
            (_ctx.activePost.custom_fields.author && _ctx.activePost.custom_fields.author.custom_fields)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: "bottom-author",
                  class: _normalizeClass(_ctx.activePost.custom_fields.author.custom_fields.language)
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.activePost.custom_fields.author.custom_fields.image)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "image box-shadow reversed",
                          href: "",
                          onClick: _cache[0] || (_cache[0] = $event => (_ctx.goToAuthor(_ctx.activePost.custom_fields.author,$event))),
                          style: _normalizeStyle({ 'background-image': 'url('+_ctx.activePost.custom_fields.author.custom_fields.image.sizes.medium+')'})
                        }, null, 4))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "image box-shadow reversed",
                          href: "",
                          onClick: _cache[1] || (_cache[1] = $event => (_ctx.goToAuthor(_ctx.activePost.custom_fields.author,$event)))
                        })),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: _cache[2] || (_cache[2] = $event => (_ctx.goToAuthor(_ctx.activePost.custom_fields.author,$event)))
                        }, _toDisplayString(_ctx.activePost.custom_fields.author.post_title), 1)
                      ]),
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.activePost.custom_fields.author.custom_fields.country), 1),
                      _createElementVNode("div", {
                        class: "bio",
                        innerHTML: _ctx.activePost.custom_fields.author.post_content
                      }, null, 8, _hoisted_23)
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.relatedPost && _ctx.relatedPost.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_Carousel, { posts: _ctx.relatedPost }, null, 8, ["posts"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.lightboxSrc && _ctx.fullSlide[_ctx.currentIndex])
      ? (_openBlock(), _createBlock(_component_Lightbox, {
          key: 2,
          src: _ctx.fullSlide[_ctx.currentIndex][0],
          type: 'image',
          related: _ctx.relatedPost,
          color: '#ff5050',
          caption: _ctx.fullSlide[_ctx.currentIndex][1],
          lang: _ctx.activePost.custom_fields.language,
          colorName: 'red',
          totalSlide: _ctx.fullSlide.length,
          index: _ctx.currentIndex
        }, null, 8, ["src", "related", "caption", "lang", "totalSlide", "index"]))
      : _createCommentVNode("", true)
  ], 2))
}